import { useQuery, QueryFunction } from 'react-query';
import { getAllGnrRequests, GnrRequest, GnrRequestResponse, GnrRequestsListResponse, getGnrRequestById, GetGnrRequestByIdQueries, GetAllGnrRequestsQueries } from '../../services/apiSLTP/sites/gnrRequests';

type UseGnrRequestsQueryOptions = {
    queries?: GetAllGnrRequestsQueries;
};

const getGnrRequests: QueryFunction<GnrRequestsListResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseGnrRequestsQueryOptions];
    const { queries } = options;

    const response = await getAllGnrRequests(queries);
    return response;
};

export const useGnrRequestsQuery = (options: UseGnrRequestsQueryOptions) => {
    return useQuery(['gnrRequests', options], getGnrRequests);
};

type UseGnrRequestByIdQueryOptions = {
    queries?: GetGnrRequestByIdQueries;
};

const getGnrRequestByIdQuery: QueryFunction<GnrRequestResponse> = async ({ queryKey }) => {
    const [, id, options] = queryKey as [string, string, UseGnrRequestByIdQueryOptions];
    const { queries } = options;

    const response = await getGnrRequestById(id, queries);
    return response;
};

export const useGnrRequestByIdQuery = (id: string, options: UseGnrRequestByIdQueryOptions) => {
    return useQuery(['gnrRequestById', id, options], getGnrRequestByIdQuery);
};
